<div id="container"><!-- flex container -->
    <div class="box"><!-- flex item -->
        <h1>{{'tfapin' | translate | async}}</h1>
        <app-otp-input (onInputChange)="onOtpChange($event)" [config]="config"></app-otp-input>
    </div>
    <div class="box">
        <div class="checkbox-container">
            <label class="check-wrapper">
                <span class="truncate-text">{{'rmberdvc'|translate|async}} </span>
                <input type="checkbox" tabindex="-1" class="checkbox" (change)="onSelect($event)" class="checkbox"
                    [checked]="getValue()" value="false" id="device_id">
                <span class="check-mark" tabindex="0"></span>
            </label>
        </div>
    </div>
    <div class="box">
        <p>A message with a verification code has been sent to your devices. Please enter the code to continue.</p>
    </div>
    <div class="box"><!-- flex item -->
        <button type="button" class="primary-btn mr-1" (click)="handleEvent($event)"><span>{{'field.label.submit'
                | translate | async}}</span>
            <i class="fa fa-check ml-1 text-white" aria-hidden="true"></i>
        </button>
        <button type="button" class="primary-btn mr-1" (click)="generatePin($event)"><span>{{'field.label.generate_pin' | translate | async}}</span>
        <i class="fa fa-check ml-1 text-white" aria-hidden="true"></i>
    </button>
    </div>
</div>